import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmThePasswordReset } from "../../utils/firebase";
import { ToastContainer, toast } from "../../toast";
import { Spinner } from "flowbite-react";
import NavBar from "../../Common/NavBar";
import "../../components/Login/Login.css";
import "./ResetPassword.css";

const defaultFormFields = {
  password: "",
  confirmPassword: "",
};

function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [formFields, setFormFields] = useState(defaultFormFields);
  const { password, confirmPassword } = formFields;
  const [successMessage, setSuccessMessage] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // New state for loading
  let oobCode = searchParams.get("oobCode");
  const resetFormFields = () => setFormFields(defaultFormFields);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      toast.error("Passwords did not match.");
      return;
    }

    try {
      setIsLoading(true); // Set loading to true
      if (oobCode) {
        await confirmThePasswordReset(oobCode, confirmPassword);
        resetFormFields();
        setSuccessMessage(true);
        toast.success("Success! Your password has been changed.");
      } else {
        toast.error("Something is wrong; try again later!");

      }
    } catch (error) {
      switch (error.code) {
        case "auth/invalid-action-code":
          toast.error("Invalid action code. Please try again.");
          break;
        case "auth/too-many-requests":
          toast.error("Too many attempts. Please try again later.");
          break;
        default:
          toast.error("An unexpected error occurred. Please try again.");
          break;
      }

    } finally {
      setIsLoading(false); // Set loading back to false
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormFields({ ...formFields, [name]: value });
  };

  return (
    <>
      <NavBar />
      <div className="bg reset-bg">
        <ToastContainer />

        <div className="reset-shell">
          <div className="login-card reset-card">
            {successMessage ? (
              <>
                <div className="login-card__logo">
                  <img
                    className="w-auto h-16 mx-auto"
                    src="/images/favicon-removebg-preview.png"
                    alt="Better Tomorrow"
                  />
                </div>

                <h2 className="login-card__title">Password updated</h2>
                <p className="login-card__helper">
                  Success! Your password has been changed. You can now sign in with your new password.
                </p>

                <button
                  type="button"
                  className="login-form__submit"
                  onClick={() => navigate("/login")}
                >
                  Sign in
                </button>
              </>
            ) : (
              <>
                <div className="login-card__logo">
                  <img
                    className="w-auto h-16 mx-auto"
                    src="/images/favicon-removebg-preview.png"
                    alt="Better Tomorrow"
                  />
                </div>

                <h2 className="login-card__title">Reset your password</h2>

                <form className="login-form" onSubmit={handleSubmit}>
                  <label className="login-form__field" htmlFor="reset-password">
                    <span className="login-form__label">New password</span>
                    <input
                      id="reset-password"
                      type="password"
                      name="password"
                      className="login-form__input"
                      placeholder="Enter a new password"
                      value={password}
                      onChange={handleChange}
                      required
                    />
                  </label>

                  <label className="login-form__field" htmlFor="reset-confirm-password">
                    <span className="login-form__label">Confirm password</span>
                    <input
                      id="reset-confirm-password"
                      type="password"
                      name="confirmPassword"
                      className="login-form__input"
                      placeholder="Re-enter the password"
                      value={confirmPassword}
                      onChange={handleChange}
                      required
                    />
                  </label>

                  <button
                    type="submit"
                    className="login-form__submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className="inline-flex items-center gap-2">
                        <Spinner size="sm" />
                        Updating
                      </span>
                    ) : (
                      "Update password"
                    )}
                  </button>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
